import styled from 'styled-components'

import { TypeStyle, fromMd, untilMd } from '@syconium/little-miss-figgy'

export const Header = styled.header``

export const Wrapper = styled.header`
  ${fromMd} {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
`

export const Title = styled.div`
  ${TypeStyle.css.headlineExtraSmall}
  color: ${o => o.theme.color.deprecated.obsidian};
`

export const SearchWrapper = styled.div`
  ${fromMd} {
    width: 35%;
  }
`

export const MobileDelimiter = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  margin-bottom: 15px;
  padding-top: 10px;

  ${fromMd} {
    display: none;
  }
`

export const DesktopDelimiter = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  padding-top: 20px;

  ${untilMd} {
    display: none;
  }
`
